/** Vertrauensstufe einer ARKO-Antwort fürs Chat-Badge (ohne React). */

import { collectLexNormIds, extractArkoSources } from './arkoSources';
import {
  firstRisUrlFromProof,
  hasLexProofData,
  isLexRefusal,
  isVerifiedLexProof,
  type LexProof,
} from './lexProof';

export type ArkoTrustLevel = 'verified' | 'orientation';

export interface ArkoTrust {
  level: ArkoTrustLevel;
  /** Verifizierte Norm-IDs (für die Badge-Beschriftung). */
  normIds: string[];
  /** Erste klickbare RIS-URL, falls vorhanden. */
  risUrl?: string;
  /** Roher LEX-Stempel aus dem Text (Fallback ohne strukturierten Nachweis). */
  lexStamp?: string;
}

/**
 * Stuft eine Bot-Antwort als „verifiziert" (echte LEXCORE-Norm) oder „allgemeine
 * Orientierung" ein. Baut additiv auf lexProof + Text-Parsing auf — keine neue
 * Datenquelle. Ehrliche Absagen zählen bewusst als Orientierung.
 */
export function classifyArkoTrust(text: string, lexProof?: LexProof | null): ArkoTrust {
  const normIds = collectLexNormIds(text, lexProof);
  const refusal = isLexRefusal(text);

  let risUrl = firstRisUrlFromProof(lexProof);
  let lexStamp: string | undefined;
  if (!risUrl || normIds.length === 0) {
    for (const item of extractArkoSources(text)) {
      if (!risUrl && item.kind === 'ris' && item.url.startsWith('http')) risUrl = item.url;
      if (!lexStamp && item.kind === 'lex_stamp') lexStamp = item.raw;
    }
  }

  const verifiedProof = isVerifiedLexProof(lexProof);
  // Kandidaten unter der Schwelle (Quellen ohne Stempel) dürfen das Badge
  // nicht grün färben — Text und Badge müssen dieselbe Wahrheit sagen.
  const verified =
    !refusal && (verifiedProof || (!hasLexProofData(lexProof) && Boolean(lexStamp)));

  return {
    level: verified ? 'verified' : 'orientation',
    normIds: verified ? normIds : [],
    risUrl: verified ? risUrl : undefined,
    lexStamp: verified ? lexStamp : undefined,
  };
}
